import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, TitleStrategy, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { provideTransloco, TranslocoService } from '@jsverse/transloco';
import { provideTranslocoPersistLang } from '@jsverse/transloco-persist-lang';
import { provideTranslocoPreloadLangs } from '@jsverse/transloco-preload-langs';
import { lastValueFrom } from 'rxjs';
import { appRoutes } from './app.routes';
import { TranslocoHttpLoader } from './transloco-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { baseUrlInterceptor, authTokenInterceptor } from '@moawen-workspace/agency/core';
import { APP_CONFIG } from '@moawen-workspace/shared';
import { environment } from '../environments/environment.dev';
import { provideToastr } from 'ngx-toastr';
import { provideEnvironmentNgxMask } from 'ngx-mask';

export function preloadTranslations(transloco: TranslocoService) {
  return function () {
    const lang = transloco.getActiveLang() || 'en';
    transloco.setActiveLang(lang);
    return lastValueFrom(transloco.load(lang));
  };
}

export const preLoad = {
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: preloadTranslations,
  deps: [TranslocoService]
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
      withViewTransitions()
    ),
    provideHttpClient(
      withInterceptors([
        baseUrlInterceptor,
        authTokenInterceptor
      ]),
    ),
    provideTransloco({
      config: {
        availableLangs: ['en', 'ar'],
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader
    }),
    provideTranslocoPersistLang({
      storage: {
        useValue: localStorage,
      },
    }),
    importProvidersFrom([BrowserAnimationsModule]),
    provideTranslocoPreloadLangs(['en', 'ar']), provideAnimationsAsync(),
    // provideMarkdown(),
    { provide: APP_CONFIG, useValue: environment },
    provideToastr(),
    provideEnvironmentNgxMask(),
    preLoad
  ],
};
